import { Household, User } from '@hewey/shared'
import { z } from 'zod'

const KEY = 'hewey.session'

const Snapshot = z.object({ user: User, household: Household })
export type Snapshot = z.infer<typeof Snapshot>

// The last known session, kept in localStorage rather than the IndexedDB
// cache — and this is the one deliberate split. AuthProvider has to read it
// synchronously to start in `authed` instead of `loading`, which is the
// difference between opening on content and opening on the splash. A few
// hundred bytes, with /auth/me revalidating behind the first paint.
export const readSnapshot = (): Snapshot | null => {
	let raw: string | null
	try {
		raw = window.localStorage.getItem(KEY)
	} catch {
		return null
	}
	if (raw === null) return null
	try {
		const parsed = Snapshot.safeParse(JSON.parse(raw))
		return parsed.success ? parsed.data : null
	} catch {
		return null
	}
}

export const writeSnapshot = (next: Snapshot | null) => {
	try {
		if (next === null) window.localStorage.removeItem(KEY)
		else window.localStorage.setItem(KEY, JSON.stringify(next))
	} catch {
		// Storage disabled or full — the splash is the fallback.
	}
}
